import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { EstadosBrasil } from 'src/app/enum/estadosBrasil.enum';
import { ClientService } from 'src/app/service/client.service';
import { ColaboradorService } from 'src/app/service/colaborador.service';
import { PlanoService } from 'src/app/service/plano.service';
import { SegmentoService } from 'src/app/service/segmento.service';
import { ConfirmaDeleteComponent } from 'src/app/util/confirma-delete/confirma-delete.component';
import { Colaborador } from '../colaborador/colaborador';
import { DiologHistoricoClienteComponent } from '../diolog-historico-cliente/diolog-historico-cliente.component';
import { Plano } from '../plano/plano';
import { Segmento } from '../segmento/segmento';
import { Client } from './client';

@Component({
  selector: 'app-client-consulta',
  templateUrl: './client-consulta.component.html',
  styleUrls: [
    './client.component.scss',
    '../../util/conta-financeira/conta-financeira-consulta.scss',
  ],
})
export class ClientConsultaComponent implements OnInit {

  clients: Client[] = [];
  ordemColunasTabela = ['id', 'Razão Social', 'documento', 'estado', 'plano', 'acoes'];
  totalElementos = 100;
  pagina = 0;
  tamanho = 5;
  pageSizeOptions: number[] = [5, 10, 15, 100];
  mensagemErros: String[] = [];
  consultaRealizada = false;

  filtroId = '';
  filtroRazaoSocial = '';
  filtroCnpj = '';
  filtroPlano: string | null = null;
  filtroSegmento: string | null = null;
  filtroEstado: string | null = null;
  filtroColaboradorId: number | null = null;
  filtroClientePagadorId: number | null = null;

  planos: Plano[] = [];
  segmentos: Segmento[] = [];
  estados = Object.values(EstadosBrasil);
  colaboradores: Colaborador[] = [];
  clientesPagadores: Client[] = [];

  constructor(
    private clientService: ClientService,
    private planoService: PlanoService,
    private segmentoService: SegmentoService,
    private colaboradorService: ColaboradorService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.planoService.buscarPlanosAtivos().subscribe(lista => this.planos = lista ?? []);
    this.segmentoService.listarAtivos().subscribe(lista => this.segmentos = lista ?? []);
    this.colaboradorService.listarAtivos().subscribe(lista => this.colaboradores = lista ?? []);
    this.clientService.listarCliente().subscribe(lista => {
      const todos = lista ?? [];
      this.clientesPagadores = todos.filter((c: Client) => !c.clientePagadorId);
    });
  }

  novo() {
    this.router.navigate(['/client/form']);
  }

  editar(id: number) {
    this.router.navigate(['/client/form', id]);
  }

  consultar(resetPagina = true) {
    if (resetPagina) {
      this.pagina = 0;
    }

    const idLimpo = (this.filtroId || '').toString().replace(/\D/g, '');
    const idNum = idLimpo ? +idLimpo : null;

    if ((this.filtroId || '').toString().trim() && (idNum == null || Number.isNaN(idNum))) {
      this.snackBar.open('Informe um ID numérico válido.', 'ERRO', { duration: 2500 });
      return;
    }

    this.clientService.consultar({
      id: idNum,
      razaoSocial: this.filtroRazaoSocial?.trim() || null,
      documento: this.filtroCnpj?.trim() || null,
      plano: this.filtroPlano,
      segmento: this.filtroSegmento,
      estado: this.filtroEstado,
      colaboradorId: this.filtroColaboradorId,
      clientePagadorId: this.filtroClientePagadorId,
    }, this.pagina, this.tamanho).subscribe({
      next: (response) => {
        this.clients = response?.content ?? [];
        this.totalElementos = response?.totalElements ?? 0;
        this.pagina = response?.number ?? this.pagina;
        this.consultaRealizada = true;
        this.mensagemErros = [];
      },
      error: (err) => {
        if (err.status === 204) {
          this.clients = [];
          this.totalElementos = 0;
          this.consultaRealizada = true;
          this.mensagemErros = [];
          return;
        }
        this.mensagemErros = ['Erro: ' + (err.error?.message ?? 'Falha ao consultar clientes')];
      }
    });
  }

  paginar(event: PageEvent) {
    if (!this.consultaRealizada) {
      return;
    }
    this.pagina = event.pageIndex;
    this.tamanho = event.pageSize;
    this.consultar(false);
  }

  openDialog(id: number) {
    const dialogRef = this.dialog.open(ConfirmaDeleteComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.excluir(id);
      }
    });
  }

  private excluir(id: number) {
    this.clientService.delete(id).subscribe(() => {
      this.mensagemErros = [];
      this.snackBar.open('Cliente excluído com sucesso!', 'Sucesso', { duration: 2000 });
      this.consultar(false);
    }, errorResponse => {
      this.mensagemErros = ['Erro: ' + errorResponse.error.message];
    });
  }

  prepararVenda(id: number) {
    localStorage.setItem('clienteVenda', id.toString());
    this.router.navigate(['sale']);
  }

  prepararComodato(id: number) {
    localStorage.setItem('clienteComodato', id.toString());
    this.router.navigate(['comodato/form']);
  }

  historicoCliente(id: number, clientName: string): void {
    this.dialog.open(DiologHistoricoClienteComponent, {
      width: '100%',
      data: { id, clientName }
    });
  }
}
